@layer components {
  .options {
    position: absolute;
    top: 100%;
    left: 0;
    display: grid;
    width: 100%;
    max-height: calc(100vh - 160px);
    max-height: calc(100dvh - 160px);
    /* Przy otwartej klawiaturze lista kończy się nad nią (`--viewport-height` z `useViewport`). */
    max-height: min(100dvh - 160px, var(--viewport-height, 100dvh) - var(--controls-height));
    border-bottom-left-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
    overflow: auto;
    overscroll-behavior: contain;
    transition: opacity var(--duration) var(--easing);

    &[aria-hidden="true"] {
      opacity: 0;
      pointer-events: none;
    }
  }

  .empty {
    composes: field from '../styles/field.module.css';
    padding: var(--space-small);
    border-bottom-left-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
    opacity: 0.75;
    pointer-events: none;
  }

  :global(body):has(.options[aria-hidden="false"]) {
    overflow: hidden;
  }
}
